import { SxProps, Theme } from '@mui/material';
import { aiGradientTextSx } from 'common/constants/ai/aiGradient';

export const toolbarContainerSx: SxProps<Theme> = {
  display: 'flex',
  gap: 1,
  alignItems: 'center',
  my: 0.5,
};

export const createLabelsButtonSx: SxProps<Theme> = {
  textTransform: 'none',
  whiteSpace: 'nowrap',
  border: 'none',
  py: 0.25,
  px: 1,
  minHeight: 0,
  lineHeight: 1.2,
  fontSize: '0.75rem',
  '&:hover': {
    border: 'none',
    backgroundColor: 'transparent',
  },
};

export const pushMappingsButtonSx: SxProps<Theme> = {
  textTransform: 'none',
  whiteSpace: 'nowrap',
  py: 0.25,
  px: 1.5,
  minHeight: 0,
  lineHeight: 1.2,
  fontSize: '0.75rem',
};

export const aiIconSx: SxProps<Theme> = {
  width: 16,
  height: 16,
  marginRight: 0.5,
  marginTop: '4px',
};

export const menuItemAiIconSx: SxProps<Theme> = {
  width: 14,
  height: 14,
  marginRight: 1,
};

export const aiMenuItemTextSx: SxProps<Theme> = {
  ...(aiGradientTextSx as Record<string, unknown>),
  fontWeight: 500,
};

export const createLabelsTextSx: SxProps<Theme> = {
  ...(aiGradientTextSx as Record<string, unknown>),
  fontWeight: 600,
};

export const popperSx: SxProps<Theme> = {
  zIndex: 1,
};
